<template>
    <tech-template>
        <modal name="modal-show-photo" height="auto" width="90%" :scrollable="true">
            <div class="p-10 min-h-[500px]" style="z-index: 999 !important;">
                <div class="flex items-center justify-end mb-4 pb-4 border-b text-2xl">
                    <button @click="$modal.hide('modal-show-photo');">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>
                
                <img :src="selectedPhoto" class="w-full" alt="">
            </div>
        </modal>

        <modal name="modal-confirm-end" height="auto" width="90%" :scrollable="true">
            <div v-if="intervention" class="p-10 min-h-[500px]" style="z-index: 999 !important;">
                <div class="flex items-center justify-between mb-4 pb-4 border-b font-bold">
                    <h2>Confirmer la fin de l'intervention</h2>
                    <button @click="$modal.hide('modal-confirm-end');">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>

                <div class="bg-red-100 p-4 rounded" v-if="rapportIsComplete && rapportIsComplete.length > 0">
                    <p class="mb-4 text-red-600 font-bold">
                        <i class="fas fa-exclamation-triangle mr-2"></i>
                        Le rapport d'intervention n'est pas complet. Veuillez le compléter avant de terminer l'intervention.
                    </p>
                    <ul class="ml-4 list-disc text-red-600">
                        <li v-for="(error, errorIndex) in rapportIsComplete">
                            {{ error }}
                        </li>
                    </ul>
                    <button @click="$modal.hide('modal-confirm-end'); openTab = 'rapport'" class="mt-4 px-4 py-2 bg-red-600 text-white rounded">Compléter le rapport</button>
                </div>

                <div v-if="rapportIsComplete && rapportIsComplete.length <= 0" class="space-y-6">

                    <div>
                        <h2 class="text-lg font-bold mb-3">Signature du client</h2>
                        <template v-if="!form.signature_client">
                            <p class="font-bold text-orange-800 bg-orange-100 p-4 rounded mb-4">
                                <i class="fas fa-user mr-1"></i>
                                Le client confirme que l'intervention est terminée et s'est bien déroulée.
                            </p>
                            <input-signature v-model="form.signature_client" :keyName="'intervention-' + $route.params.id" />
                        </template>
                        <div v-else>
                            <img :src="form.signature_client" alt="Signature client" class="border rounded w-full">
                            <button @click="form.signature_client = null" class="mt-2 px-4 py-2 bg-gray-200 rounded">Modifier la signature</button>
                        </div>
                    </div>

                    <div v-if="form.signature_client">
                        <button :disabled="loadingEndIntervention" @click="endIntervention" class="w-full px-4 py-4 mt-8 bg-green-600 text-white rounded font-bold">
                            <template v-if="loadingEndIntervention">
                                <i class="fas fa-spinner fa-spin mr-2"></i>
                            </template>
                            <template v-if="!loadingEndIntervention">
                                <i class="fas fa-check mr-1"></i> Terminer l'intervention
                            </template>
                        </button>
                    </div>
                </div>
            </div>
        </modal>
        
        <div v-if="loadingGetIntervention">
            <div class="flex items-center justify-center h-96">
                <i class="fas fa-spinner fa-spin text-4xl text-gray-500"></i>
            </div>
        </div>
        <div v-if="!loadingGetIntervention && intervention">
            <!-- Header -->
            <!-- <header class="px-4 py-3 bg-white shadow-sm sticky top-0 z-10">
                <h1 class="text-lg font-semibold">
                    <div v-if="missionCommencee" class="w-3 h-3 rounded-full bg-red-500 animate-pulse inline-block mr-2"></div>
                    {{ missionCommencee ? 'Intervention en cours' : intervention.intervention_type.nom }}
                </h1>
                <p class="text-xs text-gray-500">{{ intervention.client.nom + ' ' + intervention.client.prenom }} — {{ intervention.adresse.adresse1 + (intervention.adresse.adresse2 ? ', ' + intervention.adresse.adresse2 : '') }}</p>
            </header> -->
            
            <div class="p-4 space-y-5">
                <!-- AVANT mission -->
                <template v-if="!missionCommencee">
                    <!-- Bloc fiche client -->
                    <section class="bg-white rounded-xl shadow-sm p-4">
                        <h2 class="text-sm font-semibold mb-2">Fiche client</h2>
                        <p class="text-sm text-gray-700">{{ intervention.client.nom + ' ' + intervention.client.prenom }}</p>
                        <p class="text-xs text-gray-500">{{ intervention.adresse.adresse1 + (intervention.adresse.adresse2 ? ', ' + intervention.adresse.adresse2 : '') }}</p>
                        <p class="text-xs text-gray-500">
                            Tél :
                            <a :href="'tel:' + intervention.client.tel" class="text-red-600 font-medium">{{ intervention.client.telephone }}</a>
                        </p>
                        
                        <div v-if="!missionCommencee" class="mt-3 flex gap-2">
                            <a :href="'tel:' + intervention.client.telephone" class="text-center flex-1 py-2 bg-red-50 text-red-700 rounded-lg text-sm font-medium">
                                <i class="fa-solid fa-phone mr-1"></i> Appeler
                            </a>
                            <button class="flex-1 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium">
                                <i class="fa-solid fa-map-location-dot mr-1"></i> GPS
                            </button>
                        </div>
                    </section>
                    
                    <!-- Bloc matériel -->
                    <section class="bg-white rounded-xl shadow-sm p-4">
                        <h2 class="text-sm font-semibold mb-2">Matériel</h2>
                        <ul class="text-xs text-gray-600 space-y-1">
                            <li v-if="intervention.appareil.type"><span class="font-medium">Type :</span> {{ intervention.appareil.type }}</li>
                            <li v-if="intervention.appareil.marque"><span class="font-medium">Marque :</span> {{ intervention.appareil.marque }}</li>
                            <li v-if="intervention.appareil.model"><span class="font-medium">Modèle :</span> {{ intervention.appareil.model }}</li>
                            <li v-if="intervention.appareil.numero_serie"><span class="font-medium">Numéro de série :</span> {{ intervention.appareil.numero_serie }}</li>
                            <li v-if="intervention.appareil.date_installation"><span class="font-medium">Date d’installation :</span> {{ intervention.appareil.date_installation | momentDate }}</li>
                            <li v-if="intervention.appareil.emplacement"><span class="font-medium">Emplacement :</span> {{ intervention.appareil.emplacement }}</li>
                            <li v-if="intervention.appareil.note"><span class="font-medium">Notes internes :</span> {{ intervention.appareil.note }}</li>
                        </ul>
                    </section>
                    
                    <!-- Historique interventions -->
                    <section class="bg-white rounded-xl shadow-sm p-4">
                        <h2 class="text-sm font-semibold mb-2">Historique des interventions</h2>
                        <div v-for="historique in intervention.historiques" :key="historique.id" class="border-t pt-2 mt-2 flex items-center gap-2 justify-between">
                            <div>
                                <div class="text-xs">{{ historique.date_intervention | momentDate }} — {{ historique.appareil.type }}</div>
                                <div class="text-sm font-semibold">{{ historique.intervention_type.nom }}</div>
                            </div>
                            <div>
                                <button @click="alert('Voir le rapport d’intervention ID ' + historique.id)" class="text-red-600 text-sm font-medium">
                                    <i class="fas fa-eye"></i>
                                </button>
                            </div>
                        </div>
                    </section>
                    
                    <!-- Actions -->
                    <section class="space-y-2">
                        <button @click="startMission" class="w-full py-3 bg-green-600 text-white font-medium rounded-lg active:scale-95 transition-all">
                            Commencer la mission
                        </button>
                        <button @click="showAnnuler = true" class="w-full py-3 bg-red-100 text-red-700 font-medium rounded-lg active:scale-95 transition-all">
                            Annuler la mission
                        </button>
                    </section>
                    
                    <!-- Modal annulation -->
                    <div v-if="showAnnuler" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                        <div class="bg-white w-11/12 rounded-xl p-4 space-y-3">
                            <h3 class="text-sm font-semibold">Motif d’annulation</h3>
                            <div class="flex flex-wrap gap-2">
                                <button v-for="m in motifsPredefinis" :key="m" @click="motifText = m" class="text-xs px-2 py-1 bg-gray-100 rounded-lg text-gray-700">
                                    {{ m }}
                                </button>
                            </div>
                            <textarea v-model="motifText" placeholder="Autre motif..." class="w-full border border-gray-300 rounded-lg text-sm p-2 mt-2" rows="3"></textarea>
                            <div class="flex justify-end gap-10">
                                <button @click="showAnnuler = false" class="text-sm text-gray-600">Fermer</button>
                                <button @click="validerAnnulation" class="text-sm bg-red-600 text-white px-4 py-2 rounded-lg">Valider</button>
                            </div>
                        </div>
                    </div>
                </template>
                
                <!-- PENDANT mission -->
                <template v-else>
                    <!-- Tabs -->
                    <div class="flex gap-2 mb-4">
                        <button @click="selectedMainTab = 'intervention'" :class="selectedMainTab === 'intervention' ? 'flex-1 py-3 bg-red-600 text-white font-bold rounded-lg' : 'flex-1 py-3 bg-gray-200 text-gray-700 font-bold rounded-lg'">
                            Intervention
                        </button>
                        <button @click="selectedMainTab = 'dossier'" :class="selectedMainTab === 'dossier' ? 'flex-1 py-3 bg-red-600 text-white font-bold rounded-lg' : 'flex-1 py-3 bg-gray-200 text-gray-700 font-bold rounded-lg'">
                            Dossier
                        </button>
                    </div>
                    <div class="bg-white p-4 rounded shadow-sm">
                        <div v-if="!form.imageDebut && selectedMainTab == 'intervention'">
                            <h2 class="text-lg font-bold mb-4">Photo avant intervention</h2>
                            <p class="mb-4">
                                Merci de prendre une photo avant votre intervention.<br />
                                Cette photo sera utilisée comme référence.
                            </p>
                            <input-file v-model="form.imageDebut" :keyName="'intervention-' + $route.params.id" :preview="true" mode="camera" />
                        </div>
                        <div v-if="form.imageDebut">
                            <!-- Image de référence -->
                            <div v-if="selectedMainTab == 'intervention'" :class="openTab === 'img-debut' ? 'border rounded bg-slate-100' : ''">
                                <div @click="openTab = openTab === 'img-debut' ? null : 'img-debut'" class="py-6 px-4 border-b flex items-center justify-between">
                                    <div class="font-bold"><i class="fas fa-image mr-1"></i> Image début de mission</div>
                                    <div class="flex items-center gap-2">
                                        <i class="fas fa-check-circle text-green-500"></i>
                                        <i v-if="openTab == 'img-debut'" class="fas fa-chevron-down"></i>
                                        <i v-else class="fas fa-chevron-right"></i>
                                    </div>
                                </div>
                                
                                <div class="p-4 border-t-2 border-slate-200" v-if="openTab == 'img-debut'">
                                    <img :src="form.imageDebut" class="max-h-[40vh] mx-auto" alt="">
                                    <button @click="removeImageDebut" class="mt-2 w-full py-2 bg-red-600 text-white font-medium rounded-lg active:scale-95 transition-all">
                                        <i class="fa-solid fa-trash mr-1"></i> Supprimer la photo
                                    </button>
                                </div>
                            </div>

                            <!-- Facturation -->
                            <div v-if="false && $account.account.can_invoice == 1 && selectedMainTab == 'intervention'" :class="openTab === 'facturation' ? 'border rounded bg-slate-100' : ''">
                                <div @click="openTab = openTab === 'facturation' ? null : 'facturation'" class="py-6 px-4 border-b flex items-center justify-between">
                                    <div class="font-bold"><i class="fas fa-file-invoice mr-1"></i> Facturation</div>
                                    <div class="flex items-center gap-2">
                                        <i v-if="openTab == 'facturation'" class="fas fa-chevron-down"></i>
                                        <i v-else class="fas fa-chevron-right"></i>
                                    </div>
                                </div>
                                <div class="border-t-2 border-red-200" v-if="openTab == 'facturation'">
                                    <invoice-form :id-intervention="intervention.id" />
                                </div>
                            </div>

                            <!-- Rapport -->
                            <div v-if="selectedMainTab == 'intervention'" :class="openTab === 'rapport' ? 'border rounded bg-slate-100' : ''">
                                <div @click="openTab = openTab === 'rapport' ? null : 'rapport'" class="py-6 px-4 border-b flex items-center justify-between">
                                    <div class="font-bold"><i class="fas fa-file mr-1"></i> Rapport</div>
                                    <div class="flex items-center gap-2">
                                        <div class="flex items-center gap-2">
                                            <template v-if="!form.imageFin">
                                                <i class="fas fa-times-circle text-red-500"></i>
                                            </template>
                                            <template v-if="form.imageFin">
                                                <i class="fas fa-check-circle text-green-500"></i>
                                            </template>
                                            <i v-if="openTab == 'rapport'" class="fas fa-chevron-down"></i>
                                            <i v-else class="fas fa-chevron-right"></i>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="p-4 border-t-2 border-slate-200" v-if="openTab == 'rapport'">
                                    <!-- <div class="mb-4">
                                        <label class="text-lg font-bold mb-3">Type d'appareil</label>
                                        <div>{{ intervention.appareil.type || 'Non renseigné' }}</div>
                                    </div> -->

                                    <div v-if="travauxList.length > 0" class="mb-4">
                                        <h2 class="text-lg font-bold mb-3">Travaux réalisés</h2>
                                        <div v-for="typeDetail in travauxList" :key="typeDetail.id" class="flex items-center space-x-2 pb-3">
                                            <input type="checkbox" :id="'typeDetail-' + typeDetail.libelle" v-model="form.typeInterventionDetails" :value="typeDetail" class="form-checkbox h-5 w-5 text-red-600" />
                                            <label :for="'typeDetail-' + typeDetail.libelle" class="text-lg">{{ typeDetail.libelle }}</label>
                                        </div>
                                    </div>

                                    <div v-if="hasFluid">
                                        <div class="text-xl font-bold mt-8">CERFA</div>
                                        
                                        <!-- Formulaire CERFA -->
                                        <!-- BLOC CERFA -->
                                        <div class="mt-4 space-y-5">
                                            
                                            <!-- Type d'opération -->
                                            <div>
                                                <h2 class="text-lg font-bold mb-3">Opérations réalisées</h2>
                                                
                                                <div class="space-y-2 text-lg">
                                                    <label class="flex items-center gap-2">
                                                        <input type="checkbox" class="w-6 h-6" value="complement" v-model="form.cerfa.operations">
                                                        Complément / Recharge
                                                    </label>
                                                    
                                                    <label class="flex items-center gap-2">
                                                        <input type="checkbox" class="w-6 h-6" value="recharge_totale" v-model="form.cerfa.operations">
                                                        Recharge complète
                                                    </label>
                                                    
                                                    <label class="flex items-center gap-2">
                                                        <input type="checkbox" class="w-6 h-6" value="recuperation" v-model="form.cerfa.operations">
                                                        Récupération du fluide
                                                    </label>
                                                    
                                                    <label class="flex items-center gap-2">
                                                        <input type="checkbox" class="w-6 h-6" value="mise_service" v-model="form.cerfa.operations">
                                                        Mise en service (tirage au vide)
                                                    </label>
                                                    
                                                    <label class="flex items-center gap-2">
                                                        <input type="checkbox" class="w-6 h-6" value="recherche_fuite" v-model="form.cerfa.operations">
                                                        Recherche de fuite + correction
                                                    </label>
                                                </div>
                                            </div>
                                            
                                            
                                            <!-- Quantités de fluide -->
                                            <div>
                                                <h2 class="text-lg font-bold mb-3">Quantité manipulée</h2>
                                                <div class="grid grid-cols-2 gap-4">
                                                    <div>
                                                        <label class="text-xs text-gray-600">Fluide récupéré (g)</label>
                                                        <input type="number" class="w-full border p-1.5 rounded focus:outline-none" v-model="form.cerfa.fluide_recupere">
                                                    </div>
                                                    <div>
                                                        <label class="text-xs text-gray-600">Fluide ajouté (g)</label>
                                                        <input type="number" class="w-full border p-1.5 rounded focus:outline-none" v-model="form.cerfa.fluide_ajoute">
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <!-- Tirage au vide -->
                                            <div>
                                                <h2 class="text-lg font-bold mb-3">Tirage au vide</h2>
                                                <div class="grid grid-cols-2 gap-4 mb-4">
                                                    <button @click="form.cerfa.tirage_vide = 'oui'" class="px-4 py-2 text-xl" :class="form.cerfa.tirage_vide === 'oui' ? 'bg-green-500 text-white' : 'border border-slate-400 text-slate-900'">Oui</button>
                                                    <button @click="form.cerfa.tirage_vide = 'non'; form.cerfa.tirage_vide_duree = null" class="px-4 py-2 text-xl" :class="form.cerfa.tirage_vide === 'non' ? 'bg-red-500 text-white' : 'border border-slate-400 text-slate-900'">Non</button>
                                                </div>
                                                
                                                <template v-if="form.cerfa.tirage_vide === 'oui'">
                                                    <label class="text-xs text-gray-600">Durée (minutes)</label>
                                                    <input type="number" placeholder="Durée (minutes)" class="w-full border p-1.5 rounded focus:outline-none" v-model="form.cerfa.tirage_vide_duree">
                                                </template>
                                            </div>
                                            
                                            <!-- Test d'étanchéité -->
                                            <div>
                                                <h2 class="text-lg font-bold mb-3">Test d’étanchéité</h2>
                                                <div class="grid grid-cols-2 gap-4 mb-4">
                                                    <button @click="form.cerfa.etancheite = 'oui'" class="px-4 py-2 text-xl" :class="form.cerfa.etancheite === 'oui' ? 'bg-green-500 text-white' : 'border border-slate-400 text-slate-900'">Oui</button>
                                                    <button @click="form.cerfa.etancheite = 'non'; form.cerfa.etancheite_methode = []" class="px-4 py-2 text-xl" :class="form.cerfa.etancheite === 'non' ? 'bg-red-500 text-white' : 'border border-slate-400 text-slate-900'">Non</button>
                                                </div>
                                                
                                                <template v-if="form.cerfa.etancheite === 'oui'">
                                                    <div class="mt-2 space-y-2 text-xl">
                                                        <label class="text-xs text-gray-600">Méthode pour vérifier l'étanchéité</label>
                                                        <label class="flex items-center gap-2">
                                                            <input type="checkbox" value="azote" v-model="form.cerfa.etancheite_methode" class="w-6 h-6">
                                                            Azote
                                                        </label>
                                                        <label class="flex items-center gap-2">
                                                            <input type="checkbox" value="traceur" v-model="form.cerfa.etancheite_methode" class="w-6 h-6">
                                                            Traceur UV
                                                        </label>
                                                        <label class="flex items-center gap-2">
                                                            <input type="checkbox" value="electronique" v-model="form.cerfa.etancheite_methode" class="w-6 h-6">
                                                            Détecteur électronique
                                                        </label>
                                                    </div>
                                                </template>
                                            </div>
                                            
                                            <div>
                                                <h2 class="text-lg font-bold mb-3">Photo plaque signalétique</h2>
                                                <input-file v-model="form.cerfa.photo_plaque" :preview="false" :keyName="'intervention-' + $route.params.id" />
                                                <img class="mb-3 max-h-[40vh] mx-auto" v-if="form.cerfa.photo_plaque" :src="form.cerfa.photo_plaque" alt="">
                                            </div>       
                                        </div>
                                    </div>

                                    <div>
                                        <h2 class="text-lg font-bold mb-3">Photo fin d'intervention</h2>
                                        <input-file v-model="form.imageFin" :preview="false" :keyName="'intervention-' + $route.params.id" mode="camera" />
                                        <img class="mb-3 max-h-[40vh] mx-auto" v-if="form.imageFin" :src="form.imageFin" alt="">
                                    </div>

                                    <!-- <div class="mt-8">
                                        <button @click="openTab = null" class="px-4 py-3 bg-red-500 text-white rounded w-full"><i class="fas fa-check mr-1"></i> Enregistrer le rapport</button>
                                    </div> -->
                                </div>
                            </div>
                            
                            <!-- Terminer -->
                            <template v-if="selectedMainTab == 'intervention'">
                                <button @click="$modal.show('modal-confirm-end')" class="px-4 py-3 bg-green-700 text-white rounded mt-4 w-full"><i class="fas fa-check mr-1"></i> Terminer l'intervention</button>
                            </template>
                        </div>


                        <!-- Dossier -->
                        <!-- Fiche client -->
                        <div v-if="selectedMainTab == 'dossier'" :class="openTab === 'fiche-client' ? 'border rounded bg-slate-100' : ''">
                            <div @click="openTab = openTab === 'fiche-client' ? null : 'fiche-client'" class="pt-4 px-4 pb-6 border-b flex items-center justify-between">
                                <div class="font-bold"><i class="fas fa-user mr-1"></i> Fiche client</div>
                                <i v-if="openTab == 'fiche-client'" class="fas fa-chevron-down"></i>
                                <i v-else class="fas fa-chevron-right"></i>
                            </div>
                            <div class="p-4 border-t-2 border-slate-200" v-if="openTab == 'fiche-client'">
                                <client-form v-model="intervention.client" />
                                <div class="mt-3">
                                    <button @click="saveClient" class="w-full py-2 bg-red-600 text-white font-medium rounded-lg active:scale-95 transition-all">
                                        <i class="fa-solid fa-check mr-1"></i> Enregistrer les modifications
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Appareil -->
                        <div v-if="selectedMainTab == 'dossier'" :class="openTab === 'appareil' ? 'border rounded bg-slate-100' : ''">
                            <div @click="openTab = openTab === 'appareil' ? null : 'appareil'" class="py-6 px-4 border-b flex items-center justify-between">
                                <div class="font-bold"><i class="fas fa-fire-flame-simple mr-1"></i> Appareil</div>
                                <div class="flex items-center gap-2">
                                    <i v-if="openTab == 'appareil'" class="fas fa-chevron-down"></i>
                                    <i v-else class="fas fa-chevron-right"></i>
                                </div>
                            </div>
                            
                            <div class="p-4 border-t-2 border-slate-200" v-if="openTab == 'appareil'">
                                <appareil-form v-model="intervention.appareil" />
                                <div class="mt-3">
                                    <button @click="saveAppareil" class="w-full py-2 bg-red-600 text-white font-medium rounded-lg active:scale-95 transition-all">
                                        <i class="fa-solid fa-check mr-1"></i> Enregistrer les modifications
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Pièces -->
                        <!-- <div :class="openTab === 'pieces' ? 'border rounded bg-slate-100' : ''">
                            <div @click="openTab = openTab === 'pieces' ? null : 'pieces'" class="py-6 px-4 border-b flex items-center justify-between">
                                <div class="font-bold"><i class="fas fa-cog mr-1"></i> Pieces</div>
                                <div class="flex items-center gap-2">
                                    <span class="text-sm px-2 py-0.5 rounded-full flex items-center gap-1" :class="form.pieces.length <= 0 ? 'bg-slate-200' : 'bg-red-600 text-white'">
                                        {{ form.pieces.length + ' ' + (form.pieces.length > 1 ? 'pièces' : 'pièce') }}
                                    </span>
                                    <i v-if="openTab == 'pieces'" class="fas fa-chevron-down"></i>
                                    <i v-else class="fas fa-chevron-right"></i>
                                </div>
                            </div>
                            
                            <div class="p-4 border-t-2 border-slate-200" v-if="openTab == 'pieces'">
                                <div v-for="(piece, index) in form.pieces" :key="index" class="border rounded-lg p-4 mb-4 bg-white shadow-sm">
                                    <div class="mb-3">
                                        <label class="text-sm font-medium block mb-1">Nom de la pièce</label>
                                        <input type="text" class="w-full border p-1.5 rounded focus:outline-none" v-model="piece.nom" placeholder="Ex: Sonde extérieure">
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label class="text-sm font-medium block mb-1">Quantité</label>
                                        <div class="flex items-center gap-2">
                                            <button class="px-4 py-2 bg-red-500 text-white rounded" @click="piece.quantite = Math.max(1, piece.quantite - 1)"><i class="fas fa-minus"></i></button>
                                            <input type="number" min="1" class="text-center w-full border p-1.5 rounded focus:outline-none" v-model.number="piece.quantite" @input="updatePieceTotal(index)">
                                            <button class="px-4 py-2 bg-red-500 text-white rounded" @click="piece.quantite++"><i class="fas fa-plus"></i></button>
                                        </div>
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label class="text-sm font-medium block mb-1">Prix unitaire HT (€)</label>
                                        <input type="number" min="0" class="w-full border p-1.5 rounded focus:outline-none" v-model.number="piece.prix_ht" @input="updatePieceTotal(index)">
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label class="text-sm font-medium block mb-1">Total HT (€)</label>
                                        <div class="font-bold w-full border p-1.5 rounded focus:outline-none bg-slate-100">{{ piece.total_ht.toFixed(2) }} €</div>
                                    </div>
                                    
                                    <div>
                                        <label class="text-sm font-medium block mb-1">Photo de la pièce (optionnel)</label>
                                        <input-file v-model="form.pieces[index].photo" :keyName="'intervention-' + $route.params.id + '-'+ index" />
                                    </div>
                                    
                                    <button @click="removePiece(index)" class="bg-red-600 text-white text-sm px-4 py-2 rounded">
                                        <i class="fas fa-trash mr-1"></i> Supprimer cette pièce
                                    </button>
                                </div>
                                
                                <button @click="addPiece" class="bg-gray-800 text-white text-sm px-4 py-2 rounded shadow">
                                    + Ajouter une autre pièce
                                </button>
                            </div>
                        </div> -->

                        <!-- Photos -->
                        <div v-if="selectedMainTab == 'dossier'" :class="openTab === 'photos' ? 'border rounded bg-slate-100' : ''">
                            <div @click="openTab = openTab === 'photos' ? null : 'photos'" class="py-6 px-4 flex items-center justify-between">
                                <div class="font-bold"><i class="fas fa-camera mr-1"></i> Photos</div>
                                <div class="flex items-center gap-2">
                                    <span class="bg-slate-200 text-sm px-2 py-0.5 rounded-full flex items-center gap-1">
                                        {{ form.photos.length + ' ' + (form.photos.length > 1 ? 'photos' : 'photo') }}
                                    </span>
                                    <i v-if="openTab == 'photos'" class="fas fa-chevron-down"></i>
                                    <i v-else class="fas fa-chevron-right"></i>
                                </div>
                            </div>
                            <div class="p-4 border-t-2 border-slate-200" v-if="openTab == 'photos'">
                                <input-file @input="(data) => form.photos.push(data)" :keyName="'intervention-' + $route.params.id" :preview="false" />
                                <div class="grid grid-cols-2 gap-4">
                                    <div @click="selectedPhoto = photo; $modal.show('modal-show-photo')" v-for="(photo, index) in form.photos" :key="index" class="relative">
                                        <img :src="photo" class="w-full h-32 object-cover rounded-lg" />
                                        <button @click.stop="deletePhoto(index)" class="absolute top-2 right-2 bg-red-500 text-white p-1 px-2 rounded-full">
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </tech-template>
</template>


<script>
import moment from 'moment'
import TechTemplate from '@/components/TechTemplate.vue'

import Interventions from '@/config/interventions.js'

import ClientForm from '../Client/Components/ClientForm.vue'
import AppareilForm from '../Client/Components/AppareilForm.vue'
import InvoiceForm from '../Facturation/Components/InvoiceForm.vue'

export default {
    name: 'TechInterventionView',
    components: { TechTemplate, ClientForm, AppareilForm, InvoiceForm },
    watch: {
        form: {
            deep: true,
            handler(newVal) {
                localStorage.setItem('tech-intervention-form-' + this.$route.params.id, JSON.stringify(newVal));
            }
        }
    },
    data() {
        return {
            interventions: Interventions,
            intervention: null,
            missionCommencee: false, // <- état principal
            showAnnuler: false,
            motifText: '',
            motifsPredefinis: ['Client absent', 'Accès impossible', 'Pièce manquante', 'Erreur de planning'],
            rapport: '',
            tests: [
                { id: 1, label: 'Test étanchéité', checked: false },
                { id: 2, label: 'Contrôle pression', checked: false },
                { id: 3, label: 'Test électrique', checked: false }
            ],
            photos: [],
            
            form: {
                imageDebut: null,
                imageFin: null,
                typeIntervention: null,
                typeInterventionDetails: [],
                cerfa: {
                    operations: [],
                    fluide_recupere: null,
                    fluide_ajoute: null,
                    tirage_vide: "non",
                    tirage_vide_duree: null,
                    etancheite: "non",
                    etancheite_methode: "",
                    photo_plaque: null,
                },
                pieces: [],
                signature_client: null,
                photos: [],
            },
            
            openTab: null,
            
            selectedPhoto: null,

            selectedMainTab: 'intervention',

            travauxList: [],

            loadingGetIntervention: false,
            loadingEndIntervention: false,
        }
    },
    filters: {
        momentDate(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY')
            }
            return '-'
        },
        momentDateTime(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY HH:mm')
            }
            return '-'
        }
    },
    computed: {
        hasFluid() {
            let selectedIntervention = this.interventions.find(intervention => intervention.label.toLowerCase() == this.intervention.appareil.type.toLowerCase());
            if (selectedIntervention) {
                return this.form.typeInterventionDetails.find((item) => item.manipulation_fluide == true) ? true : false;
            }
            return false
        },

        rapportIsComplete() {
            let errors = [];
            if (!this.intervention.appareil.type) {
                errors.push('Type d\'appareil non renseigné (Onglet "appareil")');
            }
            if (this.form.typeInterventionDetails.length === 0) {
                errors.push('Aucun "travaux réalisés" sélectionnés');
            }
            if (this.hasFluid) {
                if (this.form.cerfa.operations.length === 0) {
                    errors.push('Aucune opération CERFA sélectionnée');
                }
                if (this.form.cerfa.operations.includes('complement') || this.form.cerfa.operations.includes('recharge_totale')) {
                    if (!this.form.cerfa.fluide_ajoute) {
                        errors.push('Fluide ajouté non renseigné');
                    }
                }
                if (this.form.cerfa.operations.includes('recuperation')) {
                    if (!this.form.cerfa.fluide_recupere) {
                        errors.push('Fluide récupéré non renseigné');
                    }
                }
                if (this.form.cerfa.tirage_vide === 'oui' && !this.form.cerfa.tirage_vide_duree) {
                    errors.push('Durée de tirage à vide non renseignée');
                }
                if (this.form.cerfa.etancheite === 'oui' && this.form.cerfa.etancheite_methode.length === 0) {
                    errors.push('Méthode d\'étanchéité non renseignée');
                }
                if (!this.form.cerfa.photo_plaque) {
                    errors.push('Photo de la plaque non renseignée');
                }
                if (!this.form.imageFin) {
                    errors.push('Photo après intervention non renseignée');
                }
            }
            return errors;
        }
    },
    methods: {
        addPhoto() {
            const fakePhoto = 'https://placehold.co/100x100?text=Photo';
            this.photos.push(fakePhoto);
        },
        removePhoto(i) {
            this.photos.splice(i, 1);
        },
        async validerAnnulation() {
            if (!this.motifText) {
                this.$toast.error('Merci de renseigner un motif.');
                return;
            }
            let response = await this.$request.post('/interventions/' + this.$route.params.id + '/annuler', {
                motif: this.motifText
            });
            this.$toast.success('Mission annulée');
            this.$router.push({ name: 'TechToday' });
            this.showAnnuler = false;
        },
        terminerMission() {
            this.$toast.success('👉 Signature client à venir ici.');
        },
        
        async getIntervention() {
            this.loadingGetIntervention = true;
            let response = await this.$request.get('/interventions/' + this.$route.params.id);
            this.loadingGetIntervention = false;
            
            if (response) {
                this.intervention = response;
                if (this.intervention.statut.code == 'en_cours') {
                    this.missionCommencee = true;
                }

                this.travauxList = await this.$request.post('intervention-travaux/type-list', {
                    categorie: this.intervention.intervention_type.categorie,
                    type_logique: this.intervention.intervention_type.type_logique
                })
            }
        },
        
        async startMission() {
            let response = await this.$request.post('/interventions/' + this.$route.params.id + '/demarrer');
            if (response) {
                this.missionCommencee = true;
            }
        },
        
        addPiece() {
            this.form.pieces.push({ nom: "", quantite: 1, prix_ht: 0, total_ht: 0, photo: null });
        },
        removePiece(index) {
            if (confirm('Supprimer cette pièce ?')) {
                this.form.pieces.splice(index, 1);
            }
        },
        updatePieceTotal(index) {
            const piece = this.form.pieces[index];
            piece.total_ht = (piece.quantite || 0) * (piece.prix_ht || 0);
        },
        
        deletePhoto(index) {
            if (confirm('Supprimer cette photo ?')) {
                this.form.photos.splice(index, 1);
            }
        },
        
        async saveClient() {
            const id = this.intervention.client.id;
            
            const validation = this.$inpError([
                'inp-nom:required|min=3',
                'inp-email:required|email',
                'inp-siret:nullable|siret',
                'inp-telephone:required|tel',
                // 'inp-adresse1:required|min=5',
                // 'inp-code_postal:required|postal',
                // 'inp-ville:required|min=2',
                // 'inp-pays:required|min=2'
            ]);
            
            if (!validation) {
                this.$toast.error('Formulaire invalide')
                return
            }
            try {
                await this.$request.post(`/clients/${id}`, this.intervention.client)
                this.$toast.success('Client mis à jour')
                this.openTab = null;
            } catch (e) {
                this.$toast.error('Erreur lors de la mise à jour du client')
            }
        },
        
        async saveAppareil() {
            const validation = this.$inpError([
                'inp-type:required|min=3',
                'inp-marque:required|min=2',
                'inp-modele:required|min=2',
                'inp-numero_serie:required|min=3'
            ]);
            
            if (!validation) {
                this.$toast.error('Formulaire invalide')
                return
            }
            
            try {
                this.intervention.appareil.client_id = this.intervention.client.id;
                await this.$request.post(`/client-appareils/${this.intervention.appareil.id}`, this.intervention.appareil);
                this.openTab = null;
            } catch (e) {
                this.$toast.error("Erreur lors de l'enregistrement de l'appareil");
            }
        },

        async endIntervention() {
            if (this.rapportIsComplete.length > 0) {
                this.$toast.error('Le rapport est incomplet. Veuillez le compléter avant de terminer l\'intervention.');
                return;
            }

            if (!this.form.signature_client) {
                this.$toast.error('La signature du client est requise pour terminer l\'intervention.');
                return;
            }

            this.loadingEndIntervention = true;
            let response = await this.$request.post('/interventions/' + this.$route.params.id + '/terminer', {
                intervention: this.form
            });
            this.loadingEndIntervention = false
            if (response) {
                this.$toast.success('Intervention terminée');
                localStorage.removeItem('tech-intervention-form-' + this.$route.params.id);
                this.$router.push({ name: 'TechToday' });
            }
        },
        removeImageDebut() {
            if (confirm('Supprimer la photo de début d\'intervention ?')) {
                this.form.imageDebut = null;
                this.openTab = null;
            }
        }
    },
    
    mounted() {
        this.getIntervention();
        
        let savedForm = localStorage.getItem('tech-intervention-form-' + this.$route.params.id);
        if (savedForm) {
            this.form = JSON.parse(savedForm);
            console.log(JSON.stringify(this.form));
            
        }
    }
}
</script>
